/**
 * Application version information
 * Update this file when deploying new versions
 */

export const VERSION = 'V1.002-091025';

export default VERSION;
